import { useDispatch } from 'react-redux';
import { createPortal } from 'react-dom';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import styled from 'styled-components';

import TooglCustom from 'components/_parts/atoms/toogle';
import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';

import { HIT_BOARD_STATUS } from 'redux/actions/board';
import {
  HIT_CREATE_JOB_LEVEL,
  HIT_UPDATE_JOB_LEVEL,
} from 'redux/actions/organization';

import initialValues from './initialValues';
import validationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;

function JobLevel(props) {
  const {
    t, dataJobLevel, typeForm, showModal,
  } = props;
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema({ t }),
    onSubmit: (values) => {
      try {
        if (typeForm === 'update') {
          dispatch({
            type: HIT_UPDATE_JOB_LEVEL,
            payload: {
              data: values,
            },
          });
        } else {
          dispatch({
            type: HIT_CREATE_JOB_LEVEL,
            payload: {
              data: {
                ...values,
                board_id: localStorage.getItem('board_id'),
              },
            },
          });
        }

        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        dispatch({
          type: HIT_BOARD_STATUS,
          payload: {
            status: 'failed',
            message: error.message,
          },
        });
      }
    },
  });

  useEffect(() => {
    if (typeForm === 'update') {
      void formik.setValues({
        board_id: localStorage.getItem('board_id'),
        name: dataJobLevel?.name,
        description: dataJobLevel?.description || '',
        level: dataJobLevel?.level || '',
        status: dataJobLevel?.status ?? '',
      });
      void formik.setFieldValue('job_level_id', dataJobLevel?.job_level_id);
    }
  }, [dataJobLevel, props.modal]);

  useEffect(() => {
    if (showModal) {
      formik.resetForm();
    }
  }, [showModal]);

  let checked_;
  checked_ = formik.values?.status?.toString() === '1';

  return (
    props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container-activity-type d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'update' ? t('org.structure_view.modal.edit_jobLevel') : t('org.structure_view.modal.add_jobLevel')}`}
              </Label>
              <div className="">
                <div className="mt-3">
                  <Input
                    id="name-jobLevel"
                    type="text"
                    name="name"
                    placeholder={t('org.job_lvl.form.p_add_new')}
                    value={formik.values.name || ''}
                    onChange={formik.handleChange}
                    isError={formik.touched.name && Boolean(formik.errors.name)}
                    validateMessage={formik.errors.name}
                  />
                </div>
                <div className="mt-3">
                  <Input
                    id="description-jobLevel"
                    type="text"
                    name="description"
                    placeholder={t('org.job_lvl.form.p_desc')}
                    value={formik.values.description || ''}
                    onChange={formik.handleChange}
                    isError={
                      formik.touched.description
                      && Boolean(formik.errors.description)
                    }
                    validateMessage={formik.errors.description}
                  />
                </div>
                {typeForm === 'create' && (
                  <div className="mt-3">
                    <Input
                      id="level-jobLevel"
                      type="number"
                      name="level"
                      placeholder={t('org.job_lvl.form.ins_lvl')}
                      value={formik.values?.level || ''}
                      onChange={formik.handleChange}
                      isError={
                        formik.touched.level
                        && Boolean(formik.errors.level)
                      }
                      validateMessage={formik.errors.level}
                    />
                  </div>
                )}

                <div className="d-flex justify-content-between mt-4">
                  <p style={{ fontSize: '12px', fontWeight: '500' }}>{t('org.job_lvl.form.status')}</p>
                  <TooglCustom
                    id="button-visibility"
                    name="status"
                    checked={!checked_}
                    rightStatus="Inactive"
                    leftStatus="Active"
                    onChange={() => {
                      void formik.setValues({
                        ...formik.values,
                        status:
                        formik.values.status === '1' ? '0' : '1',
                      });
                    }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end mt-3 py-2">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('list_jobLevel'),
        )
  );
}

export default JobLevel;
